import { BalanceDisplay, TokenInputWithPrice } from "app/components/common";
import { COPY } from "app/constants";
import { Column } from "@bridgesplit/ui";
import { getVaultLpVirtualPrice, useActiveWallet, useVaultRestrictedWithdrawAmount } from "@bridgesplit/abf-react";
import { getUnixTs, roundDownToDecimals } from "@bridgesplit/utils";

import { useVaultWithdrawContext } from "./VaultWithdrawContext";
import { useVaultContext } from "../VaultContext";
import { useMaxVaultWithdraw, useVaultWithdrawBalance } from "./util";

export default function VaultWithdrawAmount() {
    const { form, setForm } = useVaultWithdrawContext();
    const { vaultExpanded } = useVaultContext();
    const { insufficientBalance, isLoading, balance } = useVaultWithdrawBalance();
    const { activeWallet } = useActiveWallet();
    const { userPosition } = useVaultContext();

    const now = getUnixTs();
    const vaultPrice = getVaultLpVirtualPrice(vaultExpanded, now) ?? 0;

    const maxLpToWithdraw = useVaultRestrictedWithdrawAmount({
        vaultExpanded,
        userPosition
    });
    const balances = useMaxVaultWithdraw();

    const balanceIsRestricted = (balances?.userLpBalance ?? 0) > maxLpToWithdraw;

    function setMax(amount: number) {
        const roundedMaxAmount = roundDownToDecimals(amount, vaultExpanded?.principalMetadata.decimals);
        const maxAmountToWithdraw = maxLpToWithdraw * vaultPrice;

        setForm(() => ({
            amountPrincipal: roundedMaxAmount,
            isMaxWithdraw: amount === maxAmountToWithdraw && (balances?.userLpBalance ?? 0) <= maxLpToWithdraw
        }));
    }

    return (
        <Column spacing={2}>
            <TokenInputWithPrice
                label={`You ${COPY.VAULT_WITHDRAW_CTA.toLowerCase()}`}
                value={form.amountPrincipal}
                setValue={(amount: number | undefined) => {
                    if (form.amountPrincipal === amount) return;
                    setForm({
                        amountPrincipal: amount,
                        isMaxWithdraw: false
                    });
                }}
                metadata={vaultExpanded?.principalMetadata}
                selectToken={null}
                belowInput={
                    <BalanceDisplay
                        balance={balance}
                        metadata={vaultExpanded?.principalMetadata}
                        insufficientBalance={insufficientBalance}
                        isLoading={isLoading}
                        setMax={setMax}
                        maxText={"Available"}
                        hideRefresh={!activeWallet}
                        hideRowEnd={!userPosition || !balances?.maxWithdraw}
                        hasRestrictedWithdrawal={balanceIsRestricted}
                        vaultAddress={vaultExpanded?.vault.address}
                        skipProps={!userPosition || !balances?.maxWithdraw}
                    />
                }
            />
        </Column>
    );
}
